"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["ProductCounts"] = "enableProductCounts";
    FeatureFlag["MultiFacetNav"] = "enableMultiFacetNav";
    FeatureFlag["EnrichAI"] = "enableEnrichAI";
    FeatureFlag["Measures"] = "enableMeasures";
    FeatureFlag["EnrichAIDashboard"] = "enableEnrichAIDashboard";
    FeatureFlag["StrategyMatrix"] = "enableStrategyMatrix";
    FeatureFlag["TaxonomyEdits"] = "enableTaxonomyEdits";
    FeatureFlag["EnableNewDataGrid"] = "enableNewDataGrid";
    FeatureFlag["EnableAmplitudeTracking"] = "enableAmplitudeTracking";
    FeatureFlag["EnableClarityTracking"] = "enableClarityTracking";
    FeatureFlag["EnableTracking"] = "enableTracking";
    FeatureFlag["DashboardContent"] = "enableDashboardContent";
    FeatureFlag["SyncWithGlobalTree"] = "enableSyncWithGlobalTree";
    FeatureFlag["MultiFiltering"] = "enableMultiFiltering";
    FeatureFlag["CreateCatalog"] = "enableCreateCatalog";
})(FeatureFlag || (exports.FeatureFlag = FeatureFlag = {}));
